import { Tabs as TabsPrimitive } from 'radix-ui'
import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

function Tabs({
	className,
	...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
	return (
		<TabsPrimitive.Root
			data-slot="tabs"
			className={cn('flex flex-col gap-2', className)}
			{...props}
		/>
	)
}

function TabsList({
	className,
	...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
	return (
		<TabsPrimitive.List
			data-slot="tabs-list"
			className={cn(
				'text-foreground mb-3 h-auto rounded-none bg-transparent px-0 sm:border-b',
				// Mobile: Stack vertically with gap, Desktop: Horizontal with space
				'flex flex-col gap-2 sm:flex-row sm:gap-0 sm:space-x-2',
				className,
			)}
			{...props}
		/>
	)
}

function TabsTrigger({
	className,
	...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
	return (
		<TabsPrimitive.Trigger
			data-slot="tabs-trigger"
			className={cn(
				"focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring text-foreground dark:text-muted-foreground hover:text-foreground relative inline-flex items-center justify-center gap-1.5 border border-transparent bg-transparent text-sm font-medium transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
				// Mobile: Full width with proper padding, Desktop: Auto width based on content
				'w-full px-4 py-2 sm:h-[calc(100%-1px)] sm:w-auto sm:px-2 sm:py-1',
				// Mobile: Remove whitespace-nowrap to allow text wrapping
				'sm:whitespace-nowrap',
				// Mobile active state: Background and border styling
				'data-[state=active]:bg-accent data-[state=active]:border-border data-[state=active]:rounded-md',
				// Desktop active state: Background, underline, and hover effects
				'sm:data-[state=active]:after:bg-primary sm:data-[state=active]:hover:bg-accent sm:data-[state=active]:rounded-none sm:data-[state=active]:border-transparent sm:data-[state=active]:bg-transparent',
				// Desktop-only underline effect
				'sm:hover:after:bg-primary sm:after:absolute sm:after:inset-x-0 sm:after:bottom-0 sm:after:-mb-1 sm:after:h-0.5',
				// Dark mode text color for active state
				'dark:data-[state=active]:text-foreground',
				className,
			)}
			{...props}
		/>
	)
}

function TabsContent({
	className,
	...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
	return (
		<TabsPrimitive.Content
			data-slot="tabs-content"
			className={cn('flex-1 outline-none', className)}
			{...props}
		/>
	)
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
